const localstorageKeys = {
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  AUTH_TOKEN: 'AUTH_TOKEN',
  USER_DATA: 'USER_DATA',
};

export default localstorageKeys;
